export const ConfigData = [
  {
    id: "title",
    name: "Title",
    isShow: true,
    width: "250px",
    filter: false,
  },
  {
    id: "publish_on",
    name: "Start Dates",
    isShow: true,
    width: "160px",
    filter: false,
    format: "date-time"

  },
  {
    id: "publish_end",
    name: "End Dates",
    isShow: true,
    width: "160px",
    filter: false,
    format: "date-time"

  },
  {
    id: "status",
    name: "Status",
    isShow: true,
    width: "160px",
    filter: false,

  },
  {
    id: "total_responding",
    name: "No.of respondents",
    isShow: true,
    width: "160px",
    filter: false,

  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["Edit","View Details", "Update Status", "Delete"],
    permission: {
      ["Edit"]: {
        id: "Edit",
        permission: ["survey.submit_survey"]
      },
      ["View Details"]: {
        id: "View Details",
        permission: ["survey.view_all_surveys", "survey.view_as_collaborator"]
      },
      ["Delete"]: {
        id: "Delete",
        permission: ["survey.delete_survey"],
      },
      ["Update Status"]: {
        id: "Update Status",
        permission: ["survey.publish_survey", "survey.view_as_collaborator"],
      },
    },
    isshowAction: {
      item: "status",
      children: [
        {
          id: "Update Status",
          value: "Update Status",
          notShowCondition: "Draft",
        },
        {
          id: "Update Status",
          value: "Update Status",
          notShowCondition: "Concluded",
        },
        {
          id: "Update Status",
          value: "Update Status",
          notShowCondition: "Closed",
        },                
        {
          id: "Edit",
          value: "Edit",
          notShowCondition: "Published"
        },
        {
          id: "Edit",
          value: "Edit",
          notShowCondition: "Concluded"
        },
        {
          id: "Edit",
          value: "Edit",
          notShowCondition: "Processing"
        },
        {
          id: "Edit",
          value: "Edit",
          notShowCondition: "Closed"
        }
      ],
    },
    
  },
];


export const allStatusConfig = [
  {
    id: "draft",
    name: "Draft",
  },
  {
    id: "pendingapproval",
    name: "Pending Approval",
  },
  {
    id: "scheduled",
    name: "Scheduled",
  },
  {
    id: "approve",
    name: "Approved",
  },
  {
    id: "published",
    name: "Published",
  },
  {
    id: "concluded",
    name: "Concluded",
  },
  {
    id: "closed",
    name: "Closed",
  },
  {
    id: "processing",
    name: "Processing"
  }
];

export const statusConfig = [
  {
    id: "draft",
    name: "Draft",
  },
  {
    id: "pendingapproval",
    name: "Pending Approval",
  },
  {
    id: "approve",
    name: "Approved",
  },
  {
    id: "publish",
    name: "Published",
  },
  {
    id: "conclude",
    name: "Concluded",
  },
  {
    id: "close",
    name: "Closed",
  }
];

export const statusConfigForApprove = [
  {
    id: "publish",
    name: "Published",
  },
  {
    id: "close",
    name: "Closed",
  },
  {
    id: "conclude",
    name: "Concluded",
  },
];

export const statusConfigForPublishScheduled = [
  {
    id: "close",
    name: "Closed",
  },
];

export const statusConfigForPending = [
  {
    id: "approve",
    name: "Approved",
  },
  {
    id: "publish",
    name: "Published",
  },
  {
    id: "close",
    name: "Closed",
  }
];

export const DefaulSorting = {
  id: "publish_on",
  name: "Publish On",
  isShow: true,
  width: "160px",
  filter: true,
};

export const ConfigDataForRecipient = [
  {
    id: "emp_sap_no",
    name: "SAP No",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "id",
    name: "BC No",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "name",
    name: "Name",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "depot",
    name: "Depot",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "interchange",
    name: "Interchange",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "designation",
    name: "Designation",
    isShow: true,
    width: "160px",
    filter: false,
  },
];
